import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { LineUserService } from '../../_services/line-user.service';
import { LineBotService } from '../../_services/line-bot.service';
import { Subject } from 'rxjs/Subject';
import { DialogService } from 'ng2-bootstrap-modal';
import { ConfirmComponent } from '../../_common/confirm/confirm.component';
import { AddLineUserComponent } from './add-line-user/add-line-user.component';

@Component({
    selector: 'app-line-user',
    templateUrl: './line-user.component.html',
    styleUrls: ['./line-user.component.css']
})
export class LineUserComponent implements OnInit {
    users: any;
    searchWord: string;
    delayTimer: any;
    dtOptions: DataTables.Settings = {};
    lineBotIds: any;
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    dtTrigger: Subject<any> = new Subject();
    
    //declare parameters object

    parameters: any = {};
    //declare callback object
    callback: any = {};
    
    constructor(private lineUserService: LineUserService,
        private lineBotService: LineBotService,
        private dialogService: DialogService) { }

    ngOnInit() {
        this.initDataTables();
        this.lineBotService.getAll(this.parameters).subscribe(result => {
            this.lineBotIds = result.data;
        });
    }

    initDataTables() {

        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.searchWord || '';

                //assign parameters object
                self.parameters = parameters;

                //assign callback object
                self.callback = callback;

                self.lineUserService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: "ユーザID",
                    data: "user_id",
                    name: "user_id",
                    className: "all text-justify"
                },
                {
                    title: "表示名",
                    data: "display_name",
                    name: "display_name",
                    className: "all text-justify"
                },
                {
                    title: "Line Bot Name",
                    data: "linebot_channel_name",
                    name: "linebot_channel_name",
                    className: "all text-justify"
                },
                {
                    title: "ユーザにブロックされた",
                    data: "btn_block",
                    width: '120px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "管理者にブロックされた",
                    data: "btn_admin_block",
                    width: '120px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    data: function (d) {
                        return `<button class="btn btn-sm btn-danger btn-delete">削除</button>`;
                    },
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;
                $('.btn-user-block', row).bind('click', () => {
                    self.openBlock(data);
                });
                $('.btn-admin-block', row).bind('click', () => {
                    self.openAdminBlock(data);
                });
                $('.btn-delete', row).bind('click', () => {
                    self.confirmDelete(data);
                });
                return row;
            }
        };
    }

    valuechange(newValue) {
        this.searchWord = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600);
    };

    openBlock(data) {
        this.lineUserService.block(data).subscribe(data => {
            this.loadCurrentPage();
        }, error => {

        });
    }

    openAdminBlock(data) {
        this.lineUserService.adminBlock(data).subscribe(data => {
            this.loadCurrentPage();
        }, error => {

        });
    }

    confirmDelete(data) {
        this.dialogService.addDialog(ConfirmComponent, { 
            title: '確認', 
            message: '削除しますが、よろしいでしょうか？' 
        }).subscribe((isConfirmed) => {
            if (isConfirmed) {
                this.lineUserService.delete(data.id).subscribe(data => {
                    this.loadCurrentPage();
                }, error => {

                });
            }
        });
    }

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    openModalAddLineUser() {
        let self = this;
        this.dialogService.addDialog(AddLineUserComponent, { lineBotIds: this.lineBotIds }).subscribe((isAccess) => {
            this.loadCurrentPage();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.lineUserService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/line-user/line-user.component.ts